import script from "./XDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./XDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./XDropdown.vue?vue&type=style&index=0&id=f6aaaf90&lang=scss&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6aaaf90"]])

export default __exports__